module.exports = __webpack_public_path__ + "static/img/Deyuimg_02.2d463d5c.png";